export default __webpack_public_path__ + "static/media/GsuiteButton.147d85f6.png";